// extracted by mini-css-extract-plugin
export default {"root":"hFhIf8","bg":"TtOaql","ribbon":"z3CGSM","bottom":"k3K8ck","top":"t_8qoE"};